export const RULES_TRANSLATION = {
    en: {
        txt_rules_title: 'Trading Simulator Season March 2026 Rules',

        // Rules Section
        txt_rule_1:
            '1. Event period: 3 March 2026 17:00 to 31 March 2026 17:00 UTC+7 time.',
        txt_rule_2:
            '2. Only users who have participated and passed user verification before 31 March 2026 17:00 UTC+7 time will be eligible to win prizes. Users who joined after 31 March 2026 17:00 UTC+7 will not receive a rank but will be able to trade freely.',
        txt_rule_3:
            '3. You are granted an initial credit of 10,000 USDS where you are able to buy/long and sell/short any coins available in the market. The amount will be deducted from your remaining credit. Examples are shown below.',
        txt_rule_4:
            '4. You will be awarded a rank within 24 hours after you have made 1 successful trade.',
        txt_rule_5:
            '5. Every 15 minutes your %PNL will be updated which affects your rank.',
        txt_rule_6:
            '6. There are 6 different ranks: Bronze, Silver, Gold, Diamond, Master and Grand Master depending on your and other competitor’s %PNL. Ranking criteria and rewards are displayed', // Ends before "HERE"
        text_here: 'HERE',
        txt_rule_7:
            '7. After the tournament ends, eligible users will receive the below rewards:',

        // Rule 7 Bullets
        txt_r7_pool:
            'FDS Prize Pool: Top 100 ranked users will receive FDS (Freedom Shards) token from a total prize pool of 1,500 FDS.',
        txt_r7_airdrop:
            'The rewards will be airdropped to your wallet on the Freedom World app. You must register or log in using the same email as your Bitazza Thailand account.',
        txt_r7_what_is: 'What is FDS? Learn more at: ',
        txt_r7_link:
            'https://blogth.bitazza.co.th/en/blog/understanding-freedom-shards-fds',
        txt_r7_note:
            'Reward will be airdropped around 15 working days after the season ends.',

        // Disclaimers
        txt_terms: '*Terms and conditions apply.',
        txt_disclaim_marketing:
            '**This content is provided by Bitazza Co., Ltd. using the Freedom World app, operated by Freedomverse Co., Ltd., which is not regulated by the SEC, as a marketing channel.',
        txt_disclaim_fds:
            '***Freedom Shards (FDS) are points in the Freedom World app. To spend your Freedom Shards in Freedom World, you can Download the app',
        txt_disclaim_risk:
            '****Cryptocurrencies and digital tokens involve high risks; investors may lose all investment money and should study information carefully and make investments according to their own risk profile.',

        txt_rule_8:
            '8. Bitazza reserves the right to change the rules and regulations of this event at any time.',
    },
    th: {
        txt_rules_title: 'กติกา Trading Simulator Season มีนาคม 2569',

        // Rules Section
        txt_rule_1:
            '1. ระยะเวลากิจกรรม: 3 มีนาคม 2569 เวลา 17:00 น. ถึง 31 มีนาคม 2569 เวลา 17:00 น. (UTC+7)',
        txt_rule_2:
            '2. เฉพาะผู้ใช้งานที่เข้าร่วมกิจกรรมและผ่านการยืนยันตัวตนภายในวันที่ 31 มีนาคม 2569 เวลา 17:00 น. (UTC+7) เท่านั้นจึงจะมีสิทธิ์ได้รับรางวัล ผู้ใช้งานที่เข้าร่วมหลังวันที่ 31 มีนาคม 2569 เวลา 17:00 น. (UTC+7) จะไม่ได้รับการจัดอันดับ แต่ยังสามารถทำการซื้อขายได้ตามปกติ',
        txt_rule_3:
            '3. ผู้ใช้งานจะได้รับเครดิตเริ่มต้นจำนวน 10,000 USDS ซึ่งสามารถใช้ในการซื้อ/เปิดสถานะ Long และขาย/เปิดสถานะ Short เหรียญใดก็ได้ที่มีอยู่ในตลาด โดยมูลค่าการซื้อขายจะถูกหักออกจากเครดิตคงเหลือ (ดูตัวอย่างด้านล่าง)',
        txt_rule_4:
            '4. ผู้ใช้งานจะได้รับการจัดอันดับภายใน 24 ชั่วโมง หลังจากทำการซื้อขายสำเร็จอย่างน้อย 1 รายการ',
        txt_rule_5:
            '5. ระบบจะอัปเดตค่า %PNL ทุก ๆ 15 นาที ซึ่งจะส่งผลต่ออันดับของผู้ใช้งาน',
        txt_rule_6:
            '6. มีทั้งหมด 6 ระดับอันดับ ได้แก่ Bronze, Silver, Gold, Diamond, Master และ Grand Master โดยพิจารณ จาก %PNL ของผู้ใช้งานเทียบกับผู้เข้าแข่งขันรายอื่น รายละเอียดเกณฑ์การจัดอันดับและรางวัลแสดงไว้',
        text_here: 'ที่นี่',
        txt_rule_7:
            '7. หลังจากการแข่งขันสิ้นสุดลง ผู้ใช้งานที่มีสิทธิ์จะได้รับรางวัลดังต่อไปนี้',

        // Rule 7 Bullets
        txt_r7_pool:
            'รางวัล FDS Prize Pool: ผู้ใช้งานที่มีอันดับ Top 100 จะได้รับโทเคน FDS (Freedom Shards) จากเงินรางวัลรวมทั้งหมด 1,500 FDS',
        txt_r7_airdrop:
            'รางวัลจะถูกแอร์ดรอปผ่านวอลเล็ตของคุณบนแอป Freedom World โดยคุณจะต้องสมัครหรือเข้าสู่ระบบด้วยอีเมลเดียวกันกับบัญชี Bitazza Thailand',
        txt_r7_what_is: 'FDS คืออะไร? อ่านต่อได้ที่',
        txt_r7_link: 'https://blogth.bitazza.co.th/th/blog/freedom-shards-fds',
        txt_r7_note: 'รางวัลจะถูกแอร์ดรอปภายใน 15 วันทำการหลังจากจบการแข่งขัน',

        // Disclaimers
        txt_terms: '*เงื่อนไขเป็นไปตามที่บริษัทฯ กำหนด',
        txt_disclaim_marketing:
            '**เนื้อหานี้จัดทำโดยบริษัท บิทาซซ่า จำกัด โดยใช้แอปพลิเคชัน Freedom World ซึ่งดำเนินการโดยบริษัท ฟรีดอมเวิร์ส จำกัดที่ไม่ได้ถูกกำกับโดยสำนักงาน ก.ล.ต. เป็นช่องทางในการทำการตลาด',
        txt_disclaim_fds:
            '***FDS (Freedom Shards) เป็นแต้มบนแอปพลิเคชัน Freedom World ผู้ใช้งานสามารถเข้าถึงแอปพลิเคชัน Freedom World ได้โดยดาวน์โหลดแอปพลิเคชัน',
        txt_disclaim_risk:
            '****คริปโทเคอร์เรนซีและโทเคนดิจิทัลมีความเสี่ยงสูง ท่านอาจสูญเสียเงินลงทุนได้ทั้งจํานวน โปรดศึกษาและลงทุนให้เหมาะสมกับระดับความเสี่ยงที่ยอมรับได้',

        txt_rule_8:
            '8. Bitazza ขอสงวนสิทธิ์ในการเปลี่ยนแปลงกติกาและเงื่อนไขของกิจกรรมนี้ได้ตลอดเวลา',
    },
    gl: {
        txt_rules_title: 'Trading Simulator Season March 2026 Rules',

        // Rules Section
        txt_rule_1:
            '1. Event period: 3 March 2026 17:00 to 31 March 2026 17:00 UTC+7 time.',
        txt_rule_2:
            '2. Only users who have participated and passed user verification before 31 March 2026 17:00 UTC+7 time will be eligible to win prizes. Users who joined after 31 March 2026 17:00 UTC+7 will not receive a rank but will be able to trade freely.',
        txt_rule_3:
            '3. You are granted an initial credit of 10,000 USDS where you are able to buy/long and sell/short any coins available in the market. The amount will be deducted from your remaining credit. Examples are shown below.',
        txt_rule_4:
            '4. You will be awarded a rank within 24 hours after you have made 1 successful trade.',
        txt_rule_5:
            '5. Every 15 minutes your %PNL will be updated which affects your rank.',
        txt_rule_6:
            '6. There are 6 different ranks: Bronze, Silver, Gold, Diamond, Master and Grand Master depending on your and other competitor’s %PNL. Ranking criteria and rewards are displayed',
        text_here: 'HERE',
        txt_rule_7:
            '7. After the tournament ends, eligible users will receive the below rewards:',

        // Rule 7 Bullets
        txt_r7_pool:
            'FDS Prize Pool: Top 100 ranked users will receive FDS (Freedom Shards) token from a total prize pool of 1,500 FDS.',
        txt_r7_airdrop:
            'The rewards will be airdropped to your wallet on the Freedom World app. You must register or log in using the same email as your Bitazza account.',
        txt_r7_what_is: 'What is FDS? Learn more at: ',
        txt_r7_link: 'https://blog.bitazza.com/blog/understanding-fds-gl',
        txt_r7_note:
            'Reward will be airdropped around 15 working days after the season ends.',

        // Disclaimers
        txt_terms: '*Terms and conditions apply.',
        txt_disclaim_marketing: '', // Empty in GL
        txt_disclaim_fds:
            '**Freedom Shards (FDS) are points in the Freedom World app. To spend your Freedom Shards in Freedom World, you can Download the app',
        txt_disclaim_risk: '', // Empty in GL

        txt_rule_8:
            '8. Bitazza reserves the right to change the rules and regulations of this event at any time.',
    },
}
